<template>
  <div :style="CtnStyles" class="txt-ctn">
    <div :style="innerCtnStyles" >
      <h3 :style="TitleStyles">{{title}}</h3>
      <p class="newfont" :style="TextStyles">{{text}}</p>
      <p class="newfont" :style="TextStyles">{{text2}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextBox',
  props: {
    title: String,
    text: String,
    text2: String,
    CtnStyles:{
      type:Object,
      default:function(){return {}}
    },
    innerCtnStyles:{
      type:Object,
      default:function(){return {}}
    },
    TitleStyles:{
      type:Object,
      default:function(){return {}}
    },
    TextStyles:{
      type:Object,
      default:function(){return {}}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.txt-ctn {
  width:100%;
  overflow:hidden;
}
.newfont {
  font-family:'Bodoni Elegant Regular';
  font-weight:100;
}

</style>
